module.exports = __webpack_public_path__ + "assets/media/share.94f57cd0.png";